module.exports = {
    ES_AR: 'es-AR',
    EN_US: 'en-US',
    PT_BR: 'pt-BR',
    DE_DE: 'de-DE',
};
